<div class="right-side p-5">
  <div class="section">
    <div class="card mb-3">
      <div class="card-header"><h2>Event Document Table</h2></div>
      <div class="card-body">
        <form [formGroup]="form1">
          <div class="col-lg-7 col-sm-12">
            <div class="search-container">
              <mat-form-field class="search-input w-75" appearance="outline">
                <mat-label>Search</mat-label>
                <input matInput formControlName="searchControl" />
              </mat-form-field>
              <button class="btn btn-outline-secondary p-2 mx-1 search-button" type="submit" (click)="onSearchClick(form1.get('searchControl')?.value ?? '')" id="btnSearch">
                <i class="bi bi-search fs-4"></i>
              </button>
            </div>
            <div *ngIf="form1.get('searchControl')?.invalid && (form1.get('searchControl')?.touched)">
              <small *ngIf="form1.get('searchControl')?.errors?.['pattern']" class="text-danger">
                Invalid search term.
              </small>
            </div>
          </div>



          <div class="table-responsive">
            <table mat-table [dataSource]="DocumentDetailsData" class="mat-elevation-z8 table table-striped table-bordered table-hover" matSort matSortActive="CreatedDate" matSortDirection="asc" matSortDisableClear>

              <!-- Sr. No Column -->
              <ng-container matColumnDef="SrNo">
                <th mat-header-cell *matHeaderCellDef> Sr. No. </th>
                <td mat-cell *matCellDef="let gr"> {{gr.rowNum}} </td>
              </ng-container>
              <!-- Document Name Column -->
              <ng-container matColumnDef="DocumentName">
                <th mat-header-cell *matHeaderCellDef> Document Name </th>
                <td mat-cell *matCellDef="let gr"> {{gr.documentName}} </td>
              </ng-container>
              <!-- Document Name Column -->
              <ng-container matColumnDef="DocumentType">
                <th mat-header-cell *matHeaderCellDef> Document Type </th>
                <td mat-cell *matCellDef="let gr"> {{gr.documentType}} </td>
              </ng-container>



              <!-- Created Date Column -->
              <ng-container matColumnDef="CreatedDate">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Created Date </th>
                <td mat-cell *matCellDef="let gr"> {{gr.createdDate}} </td>
              </ng-container>



              <!-- Download Column -->
              <ng-container matColumnDef="Download">
                <th mat-header-cell *matHeaderCellDef> Download </th>
                <td mat-cell *matCellDef="let gr">
                  <a *ngIf="gr.documentPath"
                     (click)="onDownload(gr.documentPath, gr.documentName); $event.preventDefault()"
                     style="cursor: pointer"
                     class="btn btn-warning btn-sm">
                    <i class="bi bi-download"></i> Download
                  </a>
                </td>
              </ng-container>

              

              <!-- Header Row -->
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <!-- Data Row -->
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
              <!-- No Data Row -->
              <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="7">No data matching the filter</td>
              </tr>
            </table>
          </div>

          <!-- Paginator -->
          <!--<mat-paginator #paginator
                         class="demo-paginator"
                         (page)="onPageChange($event)"
                         [length]="length"
                         [pageSize]="pageSize"
                         [showFirstLastButtons]="showFirstLastButtons"
                         [pageSizeOptions]="pageSizeOptions"
                         [hidePageSize]="hidePageSize"
                         [pageIndex]="pageIndex"
                         aria-label="Select page">
          </mat-paginator>-->


        </form>
      </div>
    </div>
  </div>
</div>

<div class="right-side p-5">
  <div class="section">
    <div class="card mb-3">
      <div class="card-header"><h2>Event Attendance Table</h2></div>
      <div class="card-body">
        <form [formGroup]="form1">
          <div class="col-lg-3 col-sm-6">
            <div class="search-container">
              <mat-form-field class="search-input w-75" appearance="outline">
                <mat-label>Search</mat-label>
                <input matInput formControlName="searchControl" />
              </mat-form-field>
              <button class="btn btn-outline-secondary p-2 mx-1 search-button" type="submit" (click)="onSearchClick(form1.get('searchControl')?.value ?? '')" id="btnSearch">
                <i class="bi bi-search fs-4"></i>
              </button>
            </div>
            <div *ngIf="form1.get('searchControl')?.invalid && (form1.get('searchControl')?.touched)">
              <small *ngIf="form1.get('searchControl')?.errors?.['pattern']" class="text-danger">
                Invalid search term.
              </small>
            </div>
          </div>



          <div class="table-responsive">
            <table mat-table [dataSource]="AttendanceDetailsData" class="mat-elevation-z8 table table-striped table-bordered table-hover" matSort matSortActive="CreatedDate" matSortDirection="asc" matSortDisableClear>

              <!-- Sr. No Column -->
              <ng-container matColumnDef="SrNo">
                <th mat-header-cell *matHeaderCellDef> Sr. No. </th>
                <td mat-cell *matCellDef="let ar"> {{ar.rowNum}} </td>
              </ng-container>
              <!-- Udyam Column -->
              <ng-container matColumnDef="UdyamRegistrationNumber">
                <th mat-header-cell *matHeaderCellDef> Udyam Registration Number </th>
                <td mat-cell *matCellDef="let ar"> {{ar.udyamRegistrationNumber}} </td>
              </ng-container>
              <ng-container matColumnDef="NameOfEnterprise">
                <th mat-header-cell *matHeaderCellDef> Name Of Enterprise </th>
                <td mat-cell *matCellDef="let ar"> {{ar.nameOfEnterprise}} </td>
              </ng-container>
              <ng-container matColumnDef="ParticipantName">
                <th mat-header-cell *matHeaderCellDef> Participant Name </th>
                <td mat-cell *matCellDef="let ar"> {{ar.participantName}} </td>
              </ng-container>

              <ng-container matColumnDef="MobileNumber">
                <th mat-header-cell *matHeaderCellDef> Mobile Number </th>
                <td mat-cell *matCellDef="let ar"> {{ar.mobileNumber}} </td>
              </ng-container>
              <ng-container matColumnDef="EnrollmentId">
                <th mat-header-cell *matHeaderCellDef> Enrollment Id </th>
                <td mat-cell *matCellDef="let ar"> {{ar.enrollmentId}} </td>
              </ng-container>


              <!-- Created Date Column -->
              <ng-container matColumnDef="CreatedDate">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Created Date </th>
                <td mat-cell *matCellDef="let ar"> {{ar.createdDate}} </td>
              </ng-container>


              <!-- Header Row -->
              <tr mat-header-row *matHeaderRowDef="displayedAttendanceColumns"></tr>
              <!-- Data Row -->
              <tr mat-row *matRowDef="let row; columns: displayedAttendanceColumns;"></tr>
              <!-- No Data Row -->
              <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="7">No data matching the filter</td>
              </tr>
            </table>
          </div>

          <!-- Paginator -->
          <mat-paginator #paginator
                         class="demo-paginator"
                         (page)="onPageChange($event)"
                         [length]="length"
                         [pageSize]="pageSize"
                         [showFirstLastButtons]="showFirstLastButtons"
                         [pageSizeOptions]="pageSizeOptions"
                         [hidePageSize]="hidePageSize"
                         [pageIndex]="pageIndex"
                         aria-label="Select page">
          </mat-paginator>


        </form>
      </div>
    </div>
  </div>
</div>
